export default __webpack_public_path__ + "images/passed_trainer_illustration.a85b79c59edeb07aa27898a69bee8578.svg";